import * as O from 'optics-ts';

import {UsersTableType} from '../../types/users-table-type';

/**
 * Maps a user table row to the shape expected by the table component.
 *
 * @param row User table row with the source user profile id.
 * @returns The row with the table id populated.
 */
// eslint-disable-next-line @fl/use-eta-reduction
export const rowMapper = (row: UsersTableType): UsersTableType =>
    O.set(O.optic<UsersTableType>().prop('id'))(row.userProfileId)(row);
